import { useState, useCallback,useEffect } from 'react';
import axios from 'axios';
// @mui
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Card from '@mui/material/Card';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableBody from '@mui/material/TableBody';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
import { RouterLink } from 'src/routes/components';
// utils
import { fTimestamp } from 'src/utils/format-time';
// components
import { useSettingsContext } from 'src/components/settings'
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import Scrollbar from 'src/components/scrollbar';
import Iconify from 'src/components/iconify';

import { countries } from 'src/assets/data';

import {
    useTable,
    getComparator,
    emptyRows,
    TableNoData,
    TableEmptyRows,
    TableHeadCustom,
    TableSelectedAction,
    TablePaginationCustom,
  } from 'src/components/table';

  import FormProvider, {
    RHFSwitch,
    RHFTextField,
    RHFUploadAvatar,
    RHFAutocomplete,
  } from 'src/components/hook-form';

  import SRIRecibidosTableRow from '../sri-recibidos-table-row';
  import SRIRecibidosTableToolbar from '../sri-recibidos-table-toolbar';
 

    const TABLE_HEAD = [
    { id: 'ruc', label: 'RUC' },
    { id: 'razon_social', label: 'Razón Social' },
    { id: 'documento', label: 'Documento' },
    { id: 'fecha_documento', label: 'Fecha Documento' },
    { id: 'detalle', label: 'Detalle' },
    { id: '' },
    ];
  
  const defaultFilters = {
    name: '',
    service: [],
    status: 'all',
    startDate: null,
    endDate: null,
  };

   /*  import Typography from '@mui/material/Typography';
// components
import { useSettingsContext } from 'src/components/settings';
import { DataGrid } from '@mui/x-data-grid';
// ----------------------------------------------------------------------
// ruc,razon_social,id_tipo_documento,fecha_documento
const columns = [
  {
    field: 'ruc',
    headerName: 'RUC',
    width: 120,
  },
  {
    field: 'razon_social',
    headerName: 'Razón Social',
    width: 160,
  },
  {
    field: 'id_tipo_documento',
    headerName: 'Tipo Documento',
    width: 160,
  },
  {
    field: 'fecha_documento',
    headerName: 'Fecha Documento',
    width: 160,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'detalle',
    headerName: 'Detalle',
    width: 400,
    align: 'center',
    headerAlign: 'center',
  }
  
];  */

export default function SRIRecibidosView() {
  
    const settings = useSettingsContext();

    const router = useRouter();
    
    const table = useTable({ defaultOrderBy: 'createDate' });
    
    const [tableData, setTableData] = useState([]);

    const [SRI_TIPODOCUMENTO_OPTIONS,setSRI_TIPODOCUMENTO_OPTIONS]= useState([]);

    const [filters, setFilters] = useState(defaultFilters);

    const [rucs, setRucs] = useState([]);

    const [valuedatedesde, setValuedatedesde] = useState(new Date());

    const [valuedatehasta, setValuedatehasta] = useState(new Date());

    const [rucasignado, setRucasignado] = useState(null);

    const handleFilters = useCallback(
        (name, value) => {
          table.onResetPage();
          setFilters((prevState) => ({
            ...prevState,
            [name]: value,
          }));
        },
        [table]
      );
      
    const dateError =
    filters.startDate && filters.endDate
      ? filters.startDate.getTime() > filters.endDate.getTime()
      : false;

    const dataFiltered = applyFilter({
        inputData: tableData,
        comparator: getComparator(table.order, table.orderBy),
        filters,
        dateError,
      });
    
      const dataInPage = dataFiltered.slice(
        table.page * table.rowsPerPage,
        table.page * table.rowsPerPage + table.rowsPerPage
      );

    const denseHeight = table.dense ? 56 : 76;

    const canReset =
    !!filters.name ||
    !!filters.service.length ||
    filters.status !== 'all' ||
    (!!filters.startDate && !!filters.endDate);

    const notFound = (!dataFiltered.length && canReset) || !dataFiltered.length;

   


    const handlerucasignadoChange = (event, value) => {
        setRucasignado(value);
      };

    const handleDeleteRow = useCallback(
        (id) => {
          const deleteRow = tableData.filter((row) => row.id !== id);
          setTableData(deleteRow);
    
          table.onUpdatePageDeleteRow(dataInPage.length);
        },
        [dataInPage.length, table, tableData]
      );
    
    const handleEditRow = useCallback(
    (id) => {
        router.push(paths.dashboard.invoice.edit(id));
    },
    [router]
    );

    const handleViewRow = useCallback(
    (id) => {
        router.push(paths.dashboard.invoice.details(id));
    },
    [router]
    );


    const fetchDataFromWebService = useCallback(async () => {


        if(valuedatedesde&&valuedatehasta&&rucasignado){
            const formattedDateDesde = valuedatedesde.toISOString().split('T')[0];
            const formattedDateHasta = valuedatehasta.toISOString().split('T')[0];
            // console.log(formattedDateDesde)
            // console.log(formattedDateHasta)
            // console.log(rucasignado.ruc)
            try {
            // Enviar los valores al servicio web y obtener los datos
            const response = await axios.post('https://neola.cloud/api/index.php/Contad/getRUCSRIAsignadosDetalle', {
                ruc: rucasignado.ruc,
                dateDesde: formattedDateDesde,
                dateHasta: formattedDateHasta,
            });
        
            // Actualizar el estado de tableData con los datos recibidos
            setTableData(response.data);
            } catch (error) {
            console.error('Error al obtener datos del servicio web:', error);
            } 
        }
      }, [rucasignado, valuedatedesde,  valuedatehasta]);
    
      
    
    useEffect(() => {
      // Función asincrónica para cargar datos desde el servicio web
      const fetchData = async () => {
        try {
          const response = await axios.get('https://neola.cloud/api/index.php/Contad/getRUCSRIAsignados');  // Reemplaza con la URL real del servicio
          setRucs(response.data);  // Actualiza el estado con los datos recibidos
        } catch (error) {
          console.error('Error al cargar datos:', error);
        }
      };
  
      fetchData();  // Llama a la función para cargar datos cuando el componente se monta
    }, []); 


    useEffect(() => {
    // Llama a fetchDataFromWebService cuando alguno de los estados cambia
    fetchDataFromWebService();
    }, [rucasignado, valuedatedesde, valuedatehasta,fetchDataFromWebService]);
    
    return (
        <Container maxWidth={settings.themeStretch ? false : 'lg'}>
            
            
            <CustomBreadcrumbs
            heading="SRI"
            links={[
                {
                name: 'Dashboard',
                href: paths.dashboard.root,
                },
                {
                name: 'SRI',
                href: paths.dashboard.sri.root,
                },
                {
                name: 'Archivos Recibidos',
                },
            ]}
            action={null}
            sx={{
                mb: { xs: 3, md: 5 },
            }}
            />


            <Card>

                <Stack
                    spacing={2}
                    alignItems={{ xs: 'flex-end', md: 'center' }}
                    direction={{
                    xs: 'column',
                    md: 'row',
                    }}
                    sx={{
                    p: 2.5,
                    pr: { xs: 2.5, md: 1 },
                    }}
                >
                    <Autocomplete
                    fullWidth
                    options={rucs}
                    getOptionLabel={(option) => option.nombre}
                    renderInput={(params) => <TextField {...params} label="RUC Asignados" margin="none" />}
                    renderOption={(props, option) => (
                        <li {...props} key={option.ruc}>
                        {option.nombre}
                        </li>
                    )}
                    onChange={handlerucasignadoChange}
                    />
                    
                    <DesktopDatePicker
                    label="Desde"
                    value={valuedatedesde}
                    minDate={new Date('2017-01-01')}
                    onChange={(newValue) => {
                        setValuedatedesde(newValue);
                    }}
                    slotProps={{
                        textField: {
                        fullWidth: true,
                        margin: 'normal',
                        },
                    }}
                    />

                    <DesktopDatePicker
                    label="Hasta"
                    value={valuedatehasta}
                    minDate={new Date('2017-01-01')}
                    onChange={(newValue) => {
                        setValuedatehasta(newValue);
                    }}
                    slotProps={{
                        textField: {
                        fullWidth: true,
                        margin: 'normal',
                        },
                    }}
                    />
                </Stack>
                
                <SRIRecibidosTableToolbar
                    filters={filters}
                    onFilters={handleFilters}
                    //
                    dateError={dateError}
                    serviceOptions={SRI_TIPODOCUMENTO_OPTIONS.map((option) => option.name)}
                    valuedatedesde={valuedatedesde}
                    valuedatehasta={valuedatehasta}
                    rucasignado={rucasignado}
                />


                <TableContainer sx={{ position: 'relative', overflow: 'unset' }}>
                    <Scrollbar>
                    <Table size={table.dense ? 'small' : 'medium'} sx={{ minWidth: 800 }}>
                        <TableHeadCustom
                        order={table.order}
                        orderBy={table.orderBy}
                        headLabel={TABLE_HEAD}
                        rowCount={tableData.length}
                        numSelected={table.selected.length}
                        onSort={table.onSort}
                        onSelectAllRows={(checked) =>
                            table.onSelectAllRows(
                            checked,
                            tableData.map((row) => row.id)
                            )
                        }
                        />

                        <TableBody>
                        {dataFiltered
                            .slice(
                            table.page * table.rowsPerPage,
                            table.page * table.rowsPerPage + table.rowsPerPage
                            )
                            .map((row) => (
                            <SRIRecibidosTableRow
                                key={row.id}
                                row={row}
                                selected={table.selected.includes(row.id)}
                                onSelectRow={() => table.onSelectRow(row.id)}
                                onViewRow={() => handleViewRow(row.id)}
                                onEditRow={() => handleEditRow(row.id)}
                                onDeleteRow={() => handleDeleteRow(row.id)}
                            />
                            ))}

                        <TableEmptyRows
                            height={denseHeight}
                            emptyRows={emptyRows(table.page, table.rowsPerPage, tableData.length)}
                        />

                        <TableNoData notFound={notFound} />
                        </TableBody>
                    </Table>
                    </Scrollbar>
                </TableContainer>

                <TablePaginationCustom
                    count={dataFiltered.length}
                    page={table.page}
                    rowsPerPage={table.rowsPerPage}
                    onPageChange={table.onChangePage}
                    onRowsPerPageChange={table.onChangeRowsPerPage}
                    //
                    dense={table.dense}
                    onChangeDense={table.onChangeDense}
                />
                </Card>
        </Container>
    );
}
 

function applyFilter({ inputData, comparator, filters, dateError }) {
    const { name, status, service, startDate, endDate } = filters;
  
    const stabilizedThis = inputData.map((el, index) => [el, index]);
  
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
  
    inputData = stabilizedThis.map((el) => el[0]);
  
    if (name) {
      inputData = inputData.filter(
        (invoice) =>
          invoice.invoiceNumber.toLowerCase().indexOf(name.toLowerCase()) !== -1 ||
          invoice.invoiceTo.name.toLowerCase().indexOf(name.toLowerCase()) !== -1
      );
    }
  
    if (status !== 'all') {
      inputData = inputData.filter((invoice) => invoice.status === status);
    }
  
    if (service.length) {
      inputData = inputData.filter((invoice) =>
        invoice.items.some((filterItem) => service.includes(filterItem.service))
      );
    }
  
    if (!dateError) {
      if (startDate && endDate) {
        inputData = inputData.filter(
          (invoice) =>
            fTimestamp(invoice.createDate) >= fTimestamp(startDate) &&
            fTimestamp(invoice.createDate) <= fTimestamp(endDate)
        );
      }
    }
  
    return inputData;

}
/* <Typography variant="h4"> Lista de Documentos </Typography>

      <Box
        sx={{
          mt: 5,
          width: 1,
          height: 320,
          borderRadius: 2,
          bgcolor: (theme) => alpha(theme.palette.grey[500], 0.04),
          border: (theme) => `dashed 1px ${theme.palette.divider}`,
        }}
      >Lista .
      <DataGrid columns={columns} rows={data} checkboxSelection disableRowSelectionOnClick />
      </Box> */


      /* const settings = useSettingsContext();
  const [data, setData] = useState([]);

  useEffect(() => {
    // Función asincrónica para cargar datos desde el servicio web
    const fetchData = async () => {
      try {
        const response = await axios.get('https://neola.cloud/api/index.php/Webtools/demoLCR');  // Reemplaza con la URL real del servicio
        setData(response.data);  // Actualiza el estado con los datos recibidos
      } catch (error) {
        console.error('Error al cargar datos:', error);
      }
    };

    fetchData();  // Llama a la función para cargar datos cuando el componente se monta
  }, []);  */

  /*  import Typography from '@mui/material/Typography';
// components
import { useSettingsContext } from 'src/components/settings';
import { DataGrid } from '@mui/x-data-grid';
// ----------------------------------------------------------------------
// ruc,razon_social,id_tipo_documento,fecha_documento
const columns = [
  {
    field: 'ruc',
    headerName: 'RUC',
    width: 120,
  },
  {
    field: 'razon_social',
    headerName: 'Razón Social',
    width: 160,
  },
  {
    field: 'id_tipo_documento',
    headerName: 'Tipo Documento',
    width: 160,
  },
  {
    field: 'fecha_documento',
    headerName: 'Fecha Documento',
    width: 160,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'detalle',
    headerName: 'Detalle',
    width: 400,
    align: 'center',
    headerAlign: 'center',
  }
  
];  */